import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const searchPresentaciones = async (query, limit = 100, offset = 0) => {
  const response = await axios.post(
    `${API_URL}/api/search-presentaciones`,
    {
      query,
      limit,
      offset,
    },
    { headers: authHeader() },
  );

  return response.data;
};

export const createPresentacion = async (items) => {
  const response = await axios.post(
    `${API_URL}/api/presentaciones/create`,
    {
      items,
    },
    { headers: authHeader() },
  );

  return response.data;
};

/** Crear presentaciones con FLUX / GPT Image 2.5 Sunburst / Nano Banana.
 * Opcional: prompt (extraPrompt), folder, plantilla, marca, templateConfig, engine.
 */
export const createPresentacionReplicate = async (
  items,
  extraPrompt,
  folder,
  plantilla,
  marca,
  templateConfig,
  engine,
) => {
  const response = await axios.post(
    `${API_URL}/api/presentaciones/create-replicate`,
    {
      items,
      ...(extraPrompt ? { extraPrompt } : {}),
      ...(folder ? { folder } : {}),
      ...(plantilla ? { plantilla } : {}),
      ...(marca ? { marca } : {}),
      ...(templateConfig ? { templateConfig } : {}),
      ...(engine ? { engine } : {}),
    },
    { headers: authHeader() },
  );

  return response.data;
};

/** Crear presentación con modelo/avatar + prenda (FLUX 2 Pro). Opcional: prompt, folder, plantilla, marca, templateConfig, modelPathBack. */
export const createPresentacionAvatar = async (
  modelPath,
  items,
  extraPrompt,
  folder,
  plantilla,
  marca,
  templateConfig,
  modelPathBack,
) => {
  const response = await axios.post(
    `${API_URL}/api/presentaciones/create-avatar`,
    {
      modelPath,
      items,
      ...(extraPrompt ? { extraPrompt } : {}),
      ...(folder ? { folder } : {}),
      ...(plantilla ? { plantilla } : {}),
      ...(marca ? { marca } : {}),
      ...(templateConfig ? { templateConfig } : {}),
      ...(modelPathBack ? { modelPathBack } : {}),
    },
    { headers: authHeader() },
  );

  return response.data;
};

/** Listar carpetas de destino dentro de PRESENTACIONES_GENERADAS. */
export const getPresentacionFolders = async () => {
  const response = await axios.get(`${API_URL}/api/presentaciones/folders`, {
    headers: authHeader(),
  });
  return response.data;
};

/** Crear carpeta dentro de PRESENTACIONES_GENERADAS. */
export const createPresentacionFolder = async (folderName) => {
  const response = await axios.post(
    `${API_URL}/api/presentaciones/create-folder`,
    { folder: folderName },
    { headers: authHeader() },
  );
  return response.data;
};

/** Carpetas de diseño en Drive: .../cliente/AIDisenos */
export const getDesignFolders = async ({ temporada, customerName } = {}) => {
  const response = await axios.get(`${API_URL}/api/designs/folders`, {
    params: { temporada, customerName },
    headers: authHeader(),
  });
  return response.data;
};

/** Crea .../temporada/cliente/AIDisenos/carpeta en Drive. */
export const createDesignFolder = async ({
  folder,
  temporada,
  customerName,
}) => {
  const response = await axios.post(
    `${API_URL}/api/designs/create-folder`,
    {
      folder,
      temporada,
      customerName,
    },
    { headers: authHeader() },
  );
  return response.data;
};

/** Listar avatares (modelos) disponibles. */
export const getAvatares = async () => {
  const response = await axios.get(`${API_URL}/api/presentaciones/avatars`, {
    headers: authHeader(),
  });
  return response.data;
};

/** Subir nuevo avatar (modelo). FormData con campo "file". */
export const uploadAvatar = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const response = await axios.post(
    `${API_URL}/api/presentaciones/upload-avatar`,
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        ...authHeader(),
      },
    },
  );
  return response.data;
};

/** Listar plantillas (PDF o imagen convertida). */
export const getPlantillas = async () => {
  const response = await axios.get(`${API_URL}/api/presentaciones/plantillas`, {
    headers: authHeader(),
  });
  return response.data;
};

/** Subir plantilla (PDF o imagen). FormData con campo "file". */
export const uploadPlantilla = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const response = await axios.post(
    `${API_URL}/api/presentaciones/upload-plantilla`,
    form,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        ...authHeader(),
      },
    },
  );
  return response.data;
};

/** Catálogo de motores de imagen (modelo GPT Image activo + novedades). */
export const getImageEngines = async () => {
  const response = await axios.get(`${API_URL}/api/image-engines`, {
    headers: authHeader(),
  });
  return response.data;
};

export const checkImageEngines = async () => {
  const response = await axios.post(
    `${API_URL}/api/image-engines/check`,
    {},
    { headers: authHeader() },
  );
  return response.data;
};

export const activateImageEngine = async (replicateModel, engine) => {
  const response = await axios.post(
    `${API_URL}/api/image-engines/activate`,
    {
      replicateModel,
      ...(engine ? { engine } : {}),
    },
    { headers: authHeader() },
  );
  return response.data;
};

export const dismissImageEngine = async (replicateModel, engine) => {
  const response = await axios.post(
    `${API_URL}/api/image-engines/dismiss`,
    {
      replicateModel,
      ...(engine ? { engine } : {}),
    },
    { headers: authHeader() },
  );
  return response.data;
};

/** Tras recargar saldo en Replicate: desbloquear generaciones. */
export const clearImageEnginesCreditsBlock = async () => {
  const response = await axios.post(
    `${API_URL}/api/image-engines/clear-credits-block`,
    {},
    { headers: authHeader() },
  );
  return response.data;
};

/** Tras recargar cuota OpenAI: desbloquear meetings/gastos/embeddings. */
export const clearOpenAiCreditsBlock = async () => {
  const response = await axios.post(
    `${API_URL}/api/image-engines/clear-openai-credits-block`,
    {},
    { headers: authHeader() },
  );
  return response.data;
};

/** Subir un diseño ya generado a Google Drive (season / client / folder). */
export const saveDesignToDrive = async ({
  relativeUrl,
  filename,
  format,
  pngRelativeUrl,
  pngFilename,
  temporada,
  customerName,
  folder,
}) => {
  const response = await axios.post(
    `${API_URL}/api/designs/save-to-drive`,
    {
      relativeUrl,
      filename,
      format,
      pngRelativeUrl,
      pngFilename,
      temporada,
      customerName,
      folder,
    },
    { headers: authHeader() },
  );
  return response.data;
};

/** Crear un nuevo diseño desde prompt + referencias (se guarda en FOTOS_WEB y se indexa automático). */
export const createNuevoDiseno = async ({
  prompt,
  engine,
  mode,
  name,
  folder,
  temporada,
  customerName,
  refs,
}) => {
  const form = new FormData();
  form.append("prompt", prompt || "");
  if (engine) form.append("engine", engine);
  if (mode) form.append("mode", mode);
  if (name) form.append("name", name);
  if (folder) form.append("folder", folder);
  if (temporada) form.append("temporada", temporada);
  if (customerName) form.append("customerName", customerName);
  (refs || []).forEach((f) => form.append("refs", f));

  // No fijar Content-Type: el navegador tiene que añadir el boundary.
  // Sin boundary, multer responde 500 (Internal Server Error).
  const response = await axios.post(`${API_URL}/api/designs/create`, form, {
    headers: authHeader(),
    timeout: 200000,
  });
  return response.data;
};

/** PNG de AI Designs → SVG con Vectorton (AI-SERVICE). */
export const vectorizeDesignSvg = async ({
  pngRelativeUrl,
  relativeUrl,
  name,
  cache,
  useAi,
  model,
}) => {
  const response = await axios.post(
    `${API_URL}/api/designs/vectorize`,
    {
      pngRelativeUrl: pngRelativeUrl || relativeUrl || "",
      relativeUrl,
      name,
      cache,
      useAi,
      model,
    },
    { timeout: 5 * 60 * 1000, headers: authHeader() },
  );
  return response.data;
};
